import { createSubscriber, createStore } from '@atlassian/react-sweet-state';
import { QUICK_DATE_FILTER_ALL_TIME } from '../../common/constants';
import type { UiState } from '../../common/types';
import * as actions from './actions';

export type State = UiState;
export type Actions = typeof actions;

export const initialState: UiState = {
	zoomState: {
		type: 'none',
	},
	quickFilter: QUICK_DATE_FILTER_ALL_TIME,
};

export const Store = createStore<State, Actions>({
	name: '@cumulative-flow-diagram/ui',
	initialState,
	actions,
});

export const UiStateSubscriber = createSubscriber<State, Actions>(Store);
